import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BankMasterModule } from "./bank/bank.module";
import { BusinessSegmentModule } from "./business-segment/business-segment.module";
import { ChargeModule } from "./charge/charge.module";
import { GSTModule } from "./gst/gst.module";
import { MapChargeToBusinessSegmentModule } from "./map-charge-to-business-segment/map-charge-to-business-segment.module";
import { TDSModule } from "./tds/tds.module";
import { VerticalModule } from "./vertical/vertical.module";
import { MapIncomeToBusinessSegmentModule } from "./map-income-to-business-segment/map-income-to-business-segment.module";

export const baseRoutes: Routes = [
    {
      path: '',
      data: {
        title: 'Accounts',
      },
      children: [
        {
          path: 'gst',
          loadChildren: () => GSTModule
        },
        {
          path: 'tds',
          loadChildren: () => TDSModule
        },
        {
          path:'bank',
          loadChildren:() => BankMasterModule
        },
        {
          path:'business-segment',
          loadChildren:() => BusinessSegmentModule
        },
        {
          path:'charge',
          loadChildren:() => ChargeModule
        },
        {
          path:'map-charge-to-business-segment',
          loadChildren:() => MapChargeToBusinessSegmentModule
        },
        {
          path:'vertical',
          loadChildren:() => VerticalModule
        },
        {
          path:'map-income-to-business-segment',
          loadChildren:() => MapIncomeToBusinessSegmentModule
        }
      ]
    }
  
  
];

@NgModule({
    imports:[RouterModule.forChild(baseRoutes)],
    exports:[RouterModule]
})

export class AccountRoutingModule
{

}